enum EnvironmentVariables {
  MODE = 'MODE',
  PANORAMA_API_URL = 'VITE_PANORAMA_API_URL',
  PANORAMA_V2_API_URL = 'VITE_PANORAMA_V2_API_URL',
  ACCOUNTS_URL = 'VITE_ACCOUNTS_URL',
  CLIENT_ID = 'VITE_CLIENT_ID',
  AUTH_SECRET = 'VITE_ACCOUNTS_AUTH_TOKEN',
  CW_ELEMENTS_MFES = 'VITE_REACT_APP_CW_ELEMENTS_MFES',
  PANORAMA_APP_ID = 'VITE_PANORAMA_APP_ID',
  ENV_CW_COMPONENTS = 'VITE_ENV_CW_COMPONENTS',
  AMPLITUDE_ID = 'VITE_AMPLITUDE_ID',
  DATADOG_APP_ID = 'VITE_DATADOG_APP_ID',
  DATADOG_CLIENT_TOKEN = 'VITE_DATADOG_CLIENT_TOKEN',
  LD_CLIENT_SIDE_ID = 'VITE_LD_CLIENT_SIDE_ID'
}

export const ENV_VARIABLES = {
  ENVIRONMENT: import.meta.env[EnvironmentVariables.MODE],
  PANORAMA_API_URL: import.meta.env[EnvironmentVariables.PANORAMA_API_URL],
  PANORAMA_V2_API_URL: import.meta.env[
    EnvironmentVariables.PANORAMA_V2_API_URL
  ],
  ACCOUNTS_URL: import.meta.env[EnvironmentVariables.ACCOUNTS_URL],
  CLIENT_ID: import.meta.env[EnvironmentVariables.CLIENT_ID],
  AUTH_SECRET: import.meta.env[EnvironmentVariables.AUTH_SECRET],
  CW_ELEMENTS_MFES: import.meta.env[EnvironmentVariables.CW_ELEMENTS_MFES],
  PANORAMA_APP_ID: import.meta.env[EnvironmentVariables.PANORAMA_APP_ID],
  ENV_CW_COMPONENTS: import.meta.env[EnvironmentVariables.ENV_CW_COMPONENTS],
  AMPLITUDE_ID: import.meta.env[EnvironmentVariables.AMPLITUDE_ID],
  DATADOG_APP_ID: import.meta.env[EnvironmentVariables.DATADOG_APP_ID],
  DATADOG_CLIENT_TOKEN: import.meta.env[
    EnvironmentVariables.DATADOG_CLIENT_TOKEN
  ],
  LD_CLIENT_SIDE_ID: import.meta.env[EnvironmentVariables.LD_CLIENT_SIDE_ID]
};

/**
 * Safely checks if the current environment is production
 * @returns true if environment is production, false otherwise
 */
export const isProductionEnvironment = (): boolean => {
  return ENV_VARIABLES.ENVIRONMENT === 'production';
};
